import React from "react";
import Header from "./Header";
import Hero from "./Hero"
import Section from "./Section";
import Card from "./Card";
import Photocard from "./Photocard";
import "./App.css";

// Component
const App = () => {
  return (
    <div>
      <Header />
      <Hero />
      <Section />
    </div>
  );
};

export default App;
